import { HttpMethods, RestApi, RestRequest, RestResponse } from '@maverick/http';

const client = new RestApi('/api/international');

export const LocationService = {
	ListCountries: async (): Promise<RestResponse> => {
		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: '/countries',
		});

		return await client.ExecuteRequest(request);
	},

	ListCountryLocation: async (country: string): Promise<RestResponse> => {
		const request = new RestRequest({
			method: HttpMethods.Get,
			endpoint: `/${country}`,
		});

		return await client.ExecuteRequest(request);
	},
};
